import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IFilterIconProps {
    className?: string;
}

const FilterIcon = (props: IFilterIconProps) => {
    const className = classNames('elc-filter-icon', props.className);
    const image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' version='1.1'%3E%3Cpath d='M20 6H4V8H20V6Z' /%3E%3Cpath d='M14 11H4V13H14V11Z' /%3E%3Cpath d='M10 16H4V18H10V16Z' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'large'} image={image} />;
};

export { FilterIcon };
